var map = {
	"./alvaro.jpeg": "be55",
	"./alvaro_vaz2.jpeg": "6164",
	"./danniel.jpg": "9a3f",
	"./danniel.png": "8f34",
	"./john.jpg": "c85d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07ba";